import React, { useState } from "react";
import {
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
} from "react-bootstrap";
import Select from "react-select";
import ConfirmDeletion from "./ConfirmDeletion";
import DeleteOrderUnitIcon from "./DeleteOrderUnitIcon";

export const OrderUnitsSelector = ({
  units,
  onChange,
  value,
  removeOrderUnit,
  error,
}) => {
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  return (
    <div className="order-unit-selector form-wrapper">
      <FormGroup
        className="dropdown-selector"
        validationState={error ? "error" : null}
      >
        <ControlLabel className="order-unit-label">
          <span>Wähle die Bestelleinheit aus</span>
          {!showDeleteConfirmation && (
            <DeleteOrderUnitIcon
              onClick={() => setShowDeleteConfirmation(true)}
              tooltipText="Bestelleinheit entfernen"
            />
          )}
        </ControlLabel>
        <div className="order-unit-name-input">
          <Select
            options={units}
            value={value?.orderUnit}
            getOptionLabel={o => o.name}
            getOptionValue={o => o.id}
            onChange={newValue => onChange({ ...value, orderUnit: newValue })}
            noOptionsMessage={() => "Keine aktive Bestelleinheit gefunden"}
            placeholder="Name der Versandeinheit"
          />
        </div>

        {value?.orderUnit?.id && (
          <FormControl
            type="number"
            placeholder="Anzahl der bestellten Versandeinheiten"
            value={value?.orderUnitCount || ""}
            onChange={e =>
              onChange({
                ...value,
                orderUnitCount: e.target.valueAsNumber || 0,
              })
            }
          />
        )}
        {error && <HelpBlock>{error.message}</HelpBlock>}
        {showDeleteConfirmation && (
          <ConfirmDeletion
            onClickNo={() => setShowDeleteConfirmation(false)}
            onClickYes={removeOrderUnit}
          />
        )}
      </FormGroup>
    </div>
  );
};
